import { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { ISelectInfo } from './cacl';

export const useSelectInfo = () => {
    const default_selectInfo = {
        productkey: '',
        chargTime: 2,
        solarType: '',
        activeStep: 1, // 当前所处的步骤，
    };
    const [_selectInfo, setSelectInfoLocal] = useState<ISelectInfo>(default_selectInfo);
    const getPrevCalcSelectInfo = (): Partial<ISelectInfo> => {
        if (typeof window === 'undefined') return default_selectInfo;
        try {
            const prevCalcSelectInfo = JSON.parse(sessionStorage.getItem('CALC_SELECT_STORAGE') || '{}');
            return prevCalcSelectInfo;
        } catch {
            return default_selectInfo;
        }
    };

    const setSelectInfo = (info: ISelectInfo): void => {
        sessionStorage.setItem('CALC_SELECT_STORAGE', JSON.stringify(info));
        setSelectInfoLocal(info);
    };
    const selectInfo = getPrevCalcSelectInfo();

    useEffect(() => {
        const localSelectInfo = getPrevCalcSelectInfo();
        if (isEmpty(localSelectInfo)) {
            sessionStorage.setItem('CALC_SELECT_STORAGE', JSON.stringify(_selectInfo));
        }
    }, []);

    const res: [Partial<ISelectInfo>, (info: ISelectInfo) => void] = [selectInfo, setSelectInfo];

    return res;
};
